import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useLanguage } from './LanguageContext';
function XIcon() {
  return <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" data-id="element-298">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-299" />
    </svg>;
}
function FacebookIcon() {
  return <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" data-id="element-300">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-301" />
    </svg>;
}
function YoutubeIcon() {
  return <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" data-id="element-302">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-303" />
    </svg>;
}
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    title: t('testimonials.t1.title'),
    quote: t('testimonials.t1.quote'),
    name: t('testimonials.t1.name'),
    role: t('testimonials.t1.role'),
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: t('testimonials.t2.title'),
    quote: t('testimonials.t2.quote'),
    name: t('testimonials.t2.name'),
    role: t('testimonials.t2.role'),
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: t('testimonials.t3.title'),
    quote: t('testimonials.t3.quote'),
    name: t('testimonials.t3.name'),
    role: t('testimonials.t3.role'),
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="py-32 bg-white relative overflow-hidden" data-id="element-304">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-305">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-306">
          <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-gray-300 text-gray-500 font-medium tracking-[0.2em] uppercase text-xs mb-6" data-id="element-307">
            {t('testimonials.badge')}
          </span>
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-bodyon-teal-dark mb-6 max-w-3xl mx-auto leading-tight" data-id="element-308">
            {t('testimonials.title')}
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-309">
            {t('testimonials.subtitle')}
          </p>
        </motion.div>

        {/* Testimonials Grid — all three cards identical style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-310">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className="bg-white border border-gray-200 rounded-3xl p-8 flex flex-col justify-between hover:shadow-md transition-shadow duration-300" data-id="element-311">
              {/* Title */}
              <div data-id="element-312">
                <h3 className="font-heading font-bold text-xl text-bodyon-teal-dark mb-4" data-id="element-313">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-base" data-id="element-314">
                  {item.quote}
                </p>
              </div>

              {/* Bottom: Avatar + Name + Socials */}
              <div className="flex items-center justify-between mt-10 pt-0" data-id="element-315">
                <div className="flex items-center gap-3" data-id="element-316">
                  <img src={item.avatar} alt={item.name} className="w-12 h-12 rounded-xl object-cover" data-id="element-317" />
                  <div data-id="element-318">
                    <h4 className="font-heading font-semibold text-bodyon-teal-dark text-sm" data-id="element-319">
                      {item.name}
                    </h4>
                    <p className="text-gray-400 text-xs" data-id="element-320">{item.role}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-gray-400" data-id="element-321">
                  <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-322">
                    <XIcon data-id="element-323" />
                  </a>
                  <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-324">
                    <FacebookIcon data-id="element-325" />
                  </a>
                  <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-326">
                    <YoutubeIcon data-id="element-327" />
                  </a>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}